
import { Typography, Box, Tooltip, styled } from '@mui/material';

const HeaderRoot = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

// `inToolbar`: rendered inside the global top bar — the bar owns height and vertical
// centering, so drop the padding/background and truncate instead of wrapping, keeping the
// header the same height on every page.
export default function Header({ title, subtitle, inToolbar = false }) {
  if (!title) return null;

  const titleEl = (
    <Typography
      variant="body2"
      noWrap={inToolbar}
      sx={{
        fontWeight: 700,
        color: '#424242',
        ...(inToolbar
          ? { display: 'block' }
          : { whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block' }),
        fontSize: { xs: '0.875rem', sm: '0.95rem', md: '0.9rem', lg: '0.9rem', xl: '1.1rem' },
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
  );

  const content = subtitle ? (
    <Tooltip title={subtitle} arrow placement="right">
      {titleEl}
    </Tooltip>
  ) : (
    titleEl
  );

  if (inToolbar) {
    return (
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center' }}>
        {content}
      </Box>
    );
  }

  return (
    <HeaderRoot>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{
          flex: 1, minWidth: 0, fontSize: {
            xs: '0.875rem', sm: '0.95rem', md: '0.9rem', lg: '0.9rem', xl: '1.1rem'
          }
        }}>
          {content}
        </Box>
      </Box>
    </HeaderRoot>
  );
}
